export const ACTIVE_EMPLOYEES = 'Total Active Employees'

export const ACTIVE_LOGGED_IN = 'Active Employees Logged In'

export const ACTIVE_NOT_LOGGED_IN = 'Active Employees Who did not Login'

export const POLICY_HOLDER_TYPE = {
  INDIVIDUAL: 'INDIVIDUAL',
  CORPORATE: 'CORPORATE',
}

export const POLICYHOLDERTYPE_SMALLCASE = {
  INDIVIDUAL: 'individual',
  CORPORATE: 'corporate',
}

export const STATUS = {
  DIGITALIZING: 'DIGITALIZING',
  INVALID_DOCUMENT: 'INVALID_DOCUMENT',
  DOCUMENT_REQUIRED: 'DOCUMENT_REQUIRED',
  VERIFICATION_PENDING: 'VERIFICATION_PENDING',
}

export const MOTOR_NAMES = {
  TWO_WHEELER: 'Two-Wheeler',
  BIKE_INSURANCE: 'Bike Insurance',
  FOUR_WHEELER: 'Four-Wheeler',
  CAR_INSURANCE: 'Car Insurance',
  MOTOR_INSURANCE: 'Motor Insurance',
}

export const DOWNLOAD_DOC = 'Click to download the document'

export const DOC_UPLOAD_PENDING = 'Document Upload Pending.'

export const DOC_INCORRECT =
  'The uploaded policy document is incorrect. Kindly reupload a valid policy document.'

export const LOCATION_BASED = 'LOCATION_BASED'

export const YES = 'Yes'

export const GMC = 'GMC'

export const GTL = 'GTL'

export const GPA = 'GPA'

export const ADD_GROUP_POLICIES = 'Add Group Policies'

export const SELECT_EMPLOYEE_TO_DEL = 'Select an Employee to delete'

export const DESC = 'DESC'

export const ASC = 'ASC'

export const NO = 'No'

export const DELETE = 'Delete'

export const REQUEST_APPROVE = 'Request Approved'

export const IN_ACTIVE = 'Inactive'

export const ACTIVE = 'Active'

export const APPROVED_IMG = 'ApprovedImg'

export const DELTE_INITIATED = 'Delete Initiated'

export const ADD = 'Add'

export const REQUEST_REJECTED = 'Request Rejected'

export const ADD_INITIATED = 'Add Initiated'

export const UPDATE = 'Update'

export const UPDATE_INITIATED = 'Update Initiated'

export const DOWNLOAD_HEALTH_CARD = 'Download Health Card'

export const ASSIGN_CEO_ROLE = 'Assign CEO Role'

export const REVOKE_ROLE = 'Revoke CEO Role'

export const ASSIGN_CORP_ADMIN = 'Assign as Corporate Admin'

export const REVOKE_CORP_ADMIN = 'Revoke Corporate Admin'

export const ARE_YOU_SURE_ASSIGNING_CEO_ROLE =
  'Are you sure to assign CEO role ?'

export const ARE_YOU_SURE_TO_REVOKE_CEO_ROLE =
  'Are you sure to revoke CEO role ?'

export const ARE_YOU_SURE_TOASSIGN_AS_ADMIN =
  'Are you sure to assign Corporate Admin role ?'

export const ARE_YOU_SURE_TO_REVOKE_AS_ADMIN =
  'Are you sure to revoke Corporate Admin role ?'

export const BRANCH_BASED = 'BRANCH_BASED'

export const ADD_DEPENDENTS = 'addDependents'

export const DOWNLOAD_POLICY = 'Download Policy'

export const MULTI_SELECT_INFO = `By multi-selecting, you can add employees to all the group policies
        (GMC, GPA, and GTL) at a time`

export const PER_CATEGORY_TXT = 'Per category, you can choose only 1 policy'

export const COMING_SOON = 'Coming Soon'

export const PHONE = 'phone'

export const CANNOT_RAISE_THE_REQUEST =
  'Cannot raise the request as there is no email id associated to the account.'

export const REQUEST_CAPTURED =
  'Your request has been captured. Our team will get in touch with you.'

export const ENCOUNTERED_ERROR =
  'Encountered an error while submitting the request.'
